import { NotificationDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { DeliveriesRequiringAttentionHoverCard } from '../../../ui/components/pure/deliveries-requiring-attention/deliveries-requiring-attention-hover-card/deliveries-requiring-attention-hover-card.component';
import { mapEventsToCampaignName, mapEventsToDescriptionList } from '../notifications.maps';

export function NotificationTooltip({ notification }: { notification: NotificationDto }) {
  const heading = `${notification.channel ?? ''} notification`;
  const campaignName = mapEventsToCampaignName(notification.events);
  const events = mapEventsToDescriptionList(notification);

  return (
    <DeliveriesRequiringAttentionHoverCard
      isLoading={false}
      heading={heading}
      title={campaignName}
      events={events}
      error={''}
    ></DeliveriesRequiringAttentionHoverCard>
  );
}
